<template>
	<div class="scoreboard ">
		<div class="team-score left" :class="{ loser: them == winningTeam }">
			<div class="score-container">
				<div class="score-names-container">
					<h1>
						{{ teams[us].players[0] }} and
						{{ teams[us].players[1] }}
					</h1>
				</div>
				<div class="score-number-container">
					<div class="relative-container">
						<transition name="slide-up">
							<h1 class="score-number" :key="teams[us].score">
								{{ teams[us].score }}
							</h1>
						</transition>
					</div>
				</div>
			</div>
		</div>
		<div class="hyphen center">
			<h1><span>-</span></h1>
		</div>
		<div class="team-score right" :class="{ loser: us == winningTeam }">
			<div class="score-container">
				<div class="score-number-container">
					<div class="relative-container">
						<transition name="slide-up">
							<h1 class="score-number" :key="teams[them].score">
								{{ teams[them].score }}
							</h1>
						</transition>
					</div>
				</div>
				<div class="score-names-container">
					<h1>
						{{ teams[them].players[0] }} and
						{{ teams[them].players[1] }}
					</h1>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	computed: {
		...mapGetters(["teams", "me", "winningTeam"]),
		us() {
			return this.me % 2;
		},
		them() {
			return (this.me + 1) % 2;
		},
	},
	created() {
		// console.log(">>> SCOREBOARD.VUE");
		// console.log("this.teams", this.teams);
		// console.log();
	},
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/main.scss";

.scoreboard {
	display: grid;
	height: 100%;
	align-items: center;
	grid-template-columns: 1fr auto 1fr;
	transition: 0.3s;
	.left {
		text-align: right;
	}
	.right {
		text-align: left;
	}
	.hyphen {
		text-align: center;
		// margin: 0 8px;
	}
	h1 {
		font-weight: normal;
		font-size: 1em;
		color: $blue-lightest;
	}
	span {
		font-weight: bold;
		font-size: 2em;
		color: white;
		margin: 8px;
	}

	.hyphen {
		h1 span {
			color: $blue-light;
			font-weight: normal;
		}
	}

	.loser {
		opacity: 0.3;
	}
	&.dev {
		background: blue;
	}
}

.left {
	.score-container {
		grid-template-columns: 1fr 20px;
		.relative-container {
			h1 {
				right: 5px;
			}
		}
	}
}
.right {
	.score-container {
		grid-template-columns: 20px 1fr;
		.relative-container {
			h1 {
				left: 5px;
			}
		}
	}
}

.score-container {
	display: grid;
	// overflow: hidden;
	gap: 16px;
	height: 100%;
	align-items: center;
	&.dev {
		background-color: yellow;
		.score-names-container {
			background-color: white;
		}
		.score-number-container {
			background-color: blue;
		}
	}

	.score-number-container {
		width: 100%;
		height: 100%;
		.relative-container {
			display: grid;
			align-items: center;
			height: 100%;
			position: relative;
			z-index: 2;
			h1 {
				text-align: center;

				margin: 0;
				display: inline-block;
				position: absolute;

				font-weight: bold;
				font-size: 2em;
				color: white;
			}
		}
	}
}

// .score-number {
// 	display: inline-block;
// 	width: 40px;
// }

.slide-up-enter-active,
.slide-up-leave-active {
	transition: 0.4s;
}

.wait-for-animation {
	.slide-up-enter-active,
	.slide-up-leave-active {
		transition-delay: 2.5s;
	}
}

.slide-up-enter-from {
	transform: translateY(20px);
	opacity: 0;
}
.slide-up-leave-to {
	transform: translateY(-20px);
	opacity: 0;
}
</style>
